import React from "react";
import { connect } from "react-redux";
import { Table, Divider, Tag, Popconfirm, Button } from "antd";
import { deleteEmployeeAuth } from "../../../actions/employeeAuthAction";
import Edit from "./Edit";

const Rendertable = ({ employeeAuths, deleteEmployeeAuth, setUpdatelist }) => {
    const columns = [
        {
            title: "Employee Name",
            dataIndex: "employee_name",
            key: "employee_name",
        },
        {
            title: "Role",
            key: "role",
            render: (text, record) => (
                <span>
                    {record.is_admin && <Tag color="red">Admin</Tag>}
                    {record.is_staff && <Tag color="blue">Staff</Tag>}
                </span>
            ),
        },
        {
            title: "Remarks",
            dataIndex: "remarks",
            key: "remarks",
        },
        {
            title: "Action",
            key: "action",
            render: (text, record) => (
                <span>
                    <Edit id={record.id} initialValues={record} setUpdatelist={setUpdatelist} />
                    <Divider type="vertical" />
                    <Popconfirm
                        title="Are you sure delete this PIN setup?"
                        onConfirm={() => {
                            deleteEmployeeAuth(record.id);
                            setUpdatelist(false);
                        }}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="link" danger>Delete</Button>
                    </Popconfirm>
                </span>
            ),
        },
    ];

    return (
        <Table
            columns={columns}
            dataSource={employeeAuths}
            rowKey="id"
            pagination={{ pageSize: 10 }}
        />
    );
};

const mapStateToProps = (state) => {
    return {
        employeeAuths: Object.values(state.employeeAuth),
    };
};

export default connect(mapStateToProps, { deleteEmployeeAuth })(Rendertable);
